import { render } from "./questionForm.vue?vue&type=template&id=8763afe6&scoped=true"
import script from "./questionForm.vue?vue&type=script&lang=js"
export * from "./questionForm.vue?vue&type=script&lang=js"

import "./questionForm.vue?vue&type=style&index=0&id=8763afe6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8763afe6"]])

export default __exports__